"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _BarsOutlined = _interopRequireDefault(require("@foxui/ui-icons-svg/lib/asn/BarsOutlined"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var BarsOutlined = function BarsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _BarsOutlined.default
  }));
};

/**![bars](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC41IDE3LjVhMS41IDEuNSAwIDExMCAzIDEuNSAxLjUgMCAwMTAtM3pNMjAgMThhMSAxIDAgMTEwIDJIOWExIDEgMCAxMTAtMmgxMXpNNC41IDEwLjVhMS41IDEuNSAwIDExMCAzIDEuNSAxLjUgMCAwMTAtM3pNMjAgMTFhMSAxIDAgMDEuMTIgMkg5YTEgMSAwIDAxLS4xMi0ySDIwek00LjUgMy41YTEuNSAxLjUgMCAxMTAgMyAxLjUgMS41IDAgMDEwLTN6TTIwIDRhMSAxIDAgMDEuMTIgMkg5YTEgMSAwIDAxLS4xMi0ySDIweiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/React.forwardRef(BarsOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BarsOutlined';
}
var _default = exports.default = RefIcon;